import React from 'react'
import ChooseUs from './ChooseUs'
import Form from './Form'
import HomeBanner from './HomeBanner'
import Offer from './Offer'
import Steps from './Steps'
import Technology from './Technology'
import Header from '../Header'
import MobileFixedNavbar from '../MobileFixedNavbar'
import { isMobile } from '../../../utils/utilityManager'
// import { useEffect, useState } from 'react'
import apiManager from '../../../utils/apiManager';
import BreadCrumbSchema from '../../GSchemas/breadcrumb';
import { espotAPI } from '../../../../public/constants/constants';

class  HomePage extends React.Component {
  constructor() {
    super();
    this.state = {
      breadcrumbItems:null,
      espotName:'GI_BREADCRUMB_HOMEINTERIORS',
      shouldLoad: false
    }
  }

  // const [shouldLoad, setShouldLoad] = useState(false);

  // useEffect(() => {
  //   window.addEventListener('HI_homepageload_event', () => {
  //    setShouldLoad(true)
  //   });
  // });


  getEspotData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const {data} = response || {}
        
        this.setState({
          breadcrumbItems: data && data.data.breadcrumbItems
        });     
      })
      .catch(error => {
        
      }); 
  }

  componentDidMount(){
    this.getEspotData();
    document.addEventListener('HI_homepageload_event', event=>{
      this.setState({
        shouldLoad: true
      });
   })
  }

     render(){
  return (
    <div>
      {this.state.breadcrumbItems && <BreadCrumbSchema breadcrumbs={this.state.breadcrumbItems} />}
      <Header 
        source=''
        showModal
        pageSource="HI_Homepage"
      />
      {isMobile() ? (
        <>
          <MobileFixedNavbar
            source=''
            showModal
            pageSource="HI_Homepage" />
        </>
      ) : (
        <></>
      )}
      <HomeBanner />
      {this.state.shouldLoad ? <>  <Offer pageSource="GI_Interiors_Offers" />
      <ChooseUs />
      <Technology />
      <Steps />
      <Form /></> : <>
      </> }
     
    
    </div>
  )
}
}

export default HomePage;
